import {AnalyticsService} from '../../../../shared/services/analytics/analytics.service';
import {PathUrlEnum} from '../../../../utils/analytics.utils';
import {
  StatusService,
  StatusSuccessMessageEnum,
} from '../../../../shared/services/authentication/status.service';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {AbstractControl, FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {ErrorMessage} from '../../../../shared/models/error-message';
import PatternsUtils from '../../../../utils/patterns.utils';
import {validatorCPF} from '../../../../utils/validators';
import {SellerPJDataPayload} from "../../../../shared/models/sellerPj.model";
import { addNameSanitizers, textMinCharsValidator, textNoSpecialCharsValidator } from '../../../../helpers/validate-form.helper';

@Component({
  selector: 'app-seller-represent-pj',
  templateUrl: './seller-represent-pj.component.html',
  styleUrls: ['./seller-represent-pj.component.scss'],
})
export class SellerRepresentPjComponent implements OnInit {
  @Input() formStep: FormGroup; //depois refatorar e remover esses inputs
  @Input() dataCompany = new SellerPJDataPayload();
  @Output() currentRepresents = new EventEmitter();

  representForm: any;
  count: number[] = []; //refatoracao pendente, verificar se existe a dependencia do count nesse componente
  currentItemSelected: any;
  currentIndexSelected: any;
  isOpenModalRemoveRepresent = false;
  initialCount = 0;

  constructor(
    private statusService: StatusService,
    private analyticsService: AnalyticsService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.representForm = new FormGroup({
      represents: new FormArray([]),
    });

    this.isFormComplete();
    this.getFormData();
    this.analyticsService.track(PathUrlEnum.PROPRIETARIO_PJ_DADOS_REPRESENTANTES);
  }

  getTextFieldError(index: number, controlName: string, label: string): string {
  const control = this.representForm.get(['represents', index, controlName]) as AbstractControl | null;
  return ErrorMessage.getTextFieldError(control, label);
}

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  get representArray() {
    return this.representForm.get('represents') as FormArray;
  }

private buildRepresentGroup(data: any = {}, index: number = 0): FormGroup {
  const group = new FormGroup({
    id: new FormControl(index + 1),
    name: new FormControl(data.name || '', [
      Validators.required,
      textMinCharsValidator(),
      textNoSpecialCharsValidator(),
    ]),
    documentNumber: new FormControl(data.documentNumber || '', [
      Validators.required,
      Validators.maxLength(11),
      Validators.pattern(PatternsUtils.CPF_MAX_14_CHARS),
      validatorCPF,
    ]),
  });

  // aqui é o ponto ideal para ligar o sanitizer
  addNameSanitizers(group, {
    controlNames: ['name'],
  });

  return group;
}

  getFormData(): void {
    this.representArray.clear();
    this.count = [];
    this.initialCount = 0;

    if (this.dataCompany?.representatives?.length) {
      this.dataCompany.representatives.forEach((representative: any, idx: number) => {
        const representGroup = this.buildRepresentGroup(representative, idx);
        this.representArray.push(representGroup);
        this.count.push(idx + 1);
        this.initialCount++;
      });
    } else {
      this.addRepresent();
    }
  }

  addRepresent() {
    const idx = this.representArray.length;
    const representGroup = this.buildRepresentGroup({}, idx);

    this.representArray.push(representGroup);
    this.initialCount++;
    this.count.push(this.initialCount);
  }

  getRepresentData(index: number) {
    const represents = this.representForm.get('represents') as any;
    const selectedRepresent = represents.at(index).value;
    this.currentItemSelected = selectedRepresent;
    this.currentIndexSelected = index;
  }

  removeRepresent(index: number) {
    this.getRepresentData(index);
    const represents = this.representForm.get('represents') as any;
    represents.removeAt(index);

    for (let i = index; i < represents.length; i++) {
      const represent = represents.at(i);
      const idField = represent.get('id');
      idField.setValue(i + 1);
    }

    //refatoracao pendente, verificar se existe a dependencia do count nesse componente
    this.count.splice(index, 1);

    this.currentRepresents.emit({
      value: this.representForm.value,
      formStatus: this.representForm.status,
    });
  }

  setIsOpenModalRemoveRepresent(index: number) {
    this.getRepresentData(index);
    this.isOpenModalRemoveRepresent = true;
  }

  modalConfirmRemove() {
    this.removeRepresent(this.currentIndexSelected);
    this.statusService.showToast('success', StatusSuccessMessageEnum.EXCLUSION_REPRESENTANT);
    this.isOpenModalRemoveRepresent = false;
  }

  closeModal() {
    this.isOpenModalRemoveRepresent = false;
  }

  getErrorInvalid(label: string): string {
    return ErrorMessage.getTextInvalid(label);
  }

  isFormComplete(): void {
    this.representForm.statusChanges.subscribe(() => {
      this.currentRepresents.emit({
        value: this.representForm.value,
        formStatus: this.representForm.status,
      });
    });
  }
}
